// extracted by mini-css-extract-plugin
module.exports = {"window":"style_window__P6rZx","delegate":"style_delegate__3g_4Y","p-checkbox":"style_p-checkbox__2h0Bx"};